<!-- Testimonial Section Start -->
<div class="el-testmnl-wrapper">
    <div class="container">
        <div class="el-team-heading text-center">
            <h4 class="el-top-heading-center">Testimonials</h4>
            <h2 class="el-main-heading">What Our Students Say About Us</h2>
            <!-- <p class="el-para">Get latest news in your inbox. Consectetur adipiscing elitadipiscing elitse <br>
                ddo eiusmod tempor incididunt ut labore et dolore.</p> -->
        </div>
        <div class="row align-items-center">
            <div class="col-xl-7 col-lg-12">
                <div class="el-tesml-main-parent">
                    <div class="swiper-button-prev swiper-button-disabled">
                        <svg width="7" height="12" viewBox="0 0 7 12" fill="none">
                            <path
                                d="M6.46068 0.875485C6.18697 0.596953 5.74568 0.596953 5.47196 0.875485L0.830026 5.59917C0.778242 5.65176 0.737158 5.71423 0.709127 5.78299C0.681096 5.85176 0.666667 5.92547 0.666667 5.99992C0.666667 6.07437 0.681096 6.14808 0.709127 6.21685C0.737158 6.28561 0.778242 6.34808 0.830026 6.40067L5.47196 11.1244C5.74567 11.4029 6.18697 11.4029 6.46068 11.1244C6.73439 10.8458 6.73439 10.3968 6.46068 10.1182L2.41644 5.99708L6.46627 1.87593C6.73439 1.60308 6.73439 1.14833 6.46068 0.875485Z" />
                        </svg>
                    </div>
                    <div class="swiper-button-next">
                        <svg width="7" height="12" viewBox="0 0 7 12" fill="none">
                            <path
                                d="M0.539362 11.1245C0.813074 11.403 1.25437 11.403 1.52808 11.1245L6.17002 6.40083C6.2218 6.34824 6.26288 6.28578 6.29091 6.21701C6.31894 6.14824 6.33337 6.07453 6.33337 6.00008C6.33337 5.92563 6.31894 5.85192 6.29091 5.78315C6.26288 5.71439 6.2218 5.65192 6.17002 5.59934L1.52808 0.875648C1.25437 0.597115 0.813074 0.597115 0.539362 0.875648C0.26565 1.15418 0.26565 1.60324 0.539362 1.88178L4.5836 6.00292L0.533776 10.1241C0.26565 10.3969 0.26565 10.8517 0.539362 11.1245Z" />
                        </svg>
                    </div>
                    <div class="swiper el-testmnl-slider">
                        <div class="swiper-wrapper">
                            <div class="swiper-slide" *ngFor="let item of tesi">
                                <div class="el-tm-banner-media">
                                    <a class="video-popup" href="https://youtu.be/D0UnqGm_miA?si=M-FnoMWqNdepVQqz">
                                        <img src="{{item.img}}" alt="Client Image" [ngClass]="item.class"></a>
                                    <div class="el-tm-banner-media_content">
                                        <h6>{{item.name}}</h6>
                                        <p class="el-para"><i class="fa fa-map-marker text-info" aria-hidden="true"></i>
                                            {{item.city}}</p>
                                    </div>
                                </div>
                            </div>
                            <!-- <div class="swiper-slide">
                                <div class="el-tm-banner-media">
                                    <a class="video-popup" href="https://youtu.be/D0UnqGm_miA?si=M-FnoMWqNdepVQqz">
                                        <img src="../assets/images/all-instructor/client-2.png" alt="Client Image"></a>
                                    <div class="el-tm-banner-media_content">
                                        <h6>Prem Chandra</h6>
                                        <p class="el-para"><img src="../assets/images/all-instructor/team-icon.png"
                                                alt="icon">Maharashtra</p>
                                    </div>
                                </div>
                            </div>
                            <div class="swiper-slide">
                                <div class="el-tm-banner-media">
                                    <a class="video-popup" href="https://youtu.be/D0UnqGm_miA?si=M-FnoMWqNdepVQqz">
                                        <img src="../assets/images/all-instructor/client-1.png" alt="Client Image"></a>
                                    <div class="el-tm-banner-media_content">
                                        <h6>Deepak Kumar</h6>
                                        <p class="el-para"><img src="../assets/images/all-instructor/team-icon.png"
                                                alt="icon"> Rajasthan</p>
                                    </div>
                                </div>
                            </div>
                            <div class="swiper-slide">
                                <div class="el-tm-banner-media">
                                    <a class="video-popup" href="https://youtu.be/D0UnqGm_miA?si=M-FnoMWqNdepVQqz">
                                        <img src="../assets/images/all-instructor/client-2.png" alt="Client Image"></a>
                                    <div class="el-tm-banner-media_content">
                                        <h6>Pappu yadav </h6>
                                        <p class="el-para"><img src="../assets/images/all-instructor/team-icon.png"
                                                alt="icon">Patna, Bihar
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div class="swiper-slide">
                                <div class="el-tm-banner-media"><a class="video-popup"
                                        href="https://youtu.be/D0UnqGm_miA?si=M-FnoMWqNdepVQqz">
                                        <img src="../assets/images/all-instructor/client-1.png" alt="Client Image"></a>
                                    <div class="el-tm-banner-media_content">
                                        <h6>Pirixit Raj </h6>
                                        <p class="el-para"><img src="../assets/images/all-instructor/team-icon.png"
                                                alt="icon"> Utrakhand</p>
                                    </div>
                                </div>
                            </div>
                            <div class="swiper-slide">
                                <div class="el-tm-banner-media">
                                    <a class="video-popup" href="https://youtu.be/D0UnqGm_miA?si=M-FnoMWqNdepVQqz">
                                        <img src="../assets/images/all-instructor/client-2.png" alt="Client Image"></a>
                                    <div class="el-tm-banner-media_content">
                                        <h6>Abishek Shukla</h6>
                                        <p class="el-para"><img src="../assets/images/all-instructor/team-icon.png"
                                                alt="icon">Himachal</p>
                                    </div>
                                </div>
                            </div> -->
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-xl-5 col-lg-12">
                <div class="swiper el-temnl-text-slider">
                    <div class="swiper-wrapper">
                        <div class="swiper-slide" *ngFor="let item of tesi">
                            <div class="el-temsl-text-slider">
                                <img src="../assets/images/all-instructor/qoute.png" alt="qoute image" class="mt-2">
                                <p class="el-para">{{item.text}}
                                </p>
                                <div class="el-tesmnl-rating">
                                    <img src="../assets/images/all-instructor/like-star.png" alt="rating star">
                                    <span>5.0</span>
                                    <span class="el-temnl-rating">
                                        <img src="../assets/images/all-instructor/star.png" alt="start">
                                        <img src="../assets/images/all-instructor/star.png" alt="start">
                                        <img src="../assets/images/all-instructor/star.png" alt="start">
                                        <img src="../assets/images/all-instructor/star.png" alt="start">
                                        <img src="../assets/images/all-instructor/star.png" alt="start">
                                        <!-- <img src="../assets/images/all-instructor/star-grey.png" alt="start"> -->
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div class="swiper-slide">
                            <div class="el-temsl-text-slider">
                                <img src="../assets/images/all-instructor/qoute.png" alt="qoute image">
                                <p class="el-para">Practicing with SilverZone mock test papers boosted my confidence
                                    for
                                    my Science Olympiad. It helped me understand the
                                    concepts better.
                                </p>
                                <div class="el-tesmnl-rating">
                                    <img src="../assets/images/all-instructor/like-star.png" alt="rating star">
                                    <span>4.0</span>
                                    <span class="el-temnl-rating">
                                        <img src="../assets/images/all-instructor/star.png" alt="start">
                                        <img src="../assets/images/all-instructor/star.png" alt="start">
                                        <img src="../assets/images/all-instructor/star.png" alt="start">
                                        <img src="../assets/images/all-instructor/star.png" alt="start">
                                        <img src="../assets/images/all-instructor/star-grey.png" alt="start">
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div class="swiper-slide">
                            <div class="el-temsl-text-slider">
                                <img src="../assets/images/all-instructor/qoute.png" alt="qoute image">
                                <p class="el-para">Preparing with SilverZone Mock Tests gave me an idea of how to
                                    proceed with my final revision for the Science Olympiad.
                                </p>
                                <div class="el-tesmnl-rating">
                                    <img src="../assets/images/all-instructor/like-star.png" alt="rating star">
                                    <span>4.0</span>
                                    <span class="el-temnl-rating">
                                        <img src="../assets/images/all-instructor/star.png" alt="start">
                                        <img src="../assets/images/all-instructor/star.png" alt="start">
                                        <img src="../assets/images/all-instructor/star.png" alt="start">
                                        <img src="../assets/images/all-instructor/star.png" alt="start">
                                        <img src="../assets/images/all-instructor/star-grey.png" alt="start">
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div class="swiper-slide">
                            <div class="el-temsl-text-slider">
                                <img src="../assets/images/all-instructor/qoute.png" alt="qoute image">
                                <p class="el-para">I found SilverZone Mock Tests very helpful for my English
                                    Olympiad
                                    exam. Giving a clear understanding of how to practice
                                    better for the exam, effectively pointing out the strong concepts and the ones I
                                    needed to work more on. Doing this
                                    series of mock tests boosted my confidence on exam day.
                                </p>
                                <div class="el-tesmnl-rating">
                                    <img src="../assets/images/all-instructor/like-star.png" alt="rating star">
                                    <span>4.0</span>
                                    <span class="el-temnl-rating">
                                        <img src="../assets/images/all-instructor/star.png" alt="start">
                                        <img src="../assets/images/all-instructor/star.png" alt="start">
                                        <img src="../assets/images/all-instructor/star.png" alt="start">
                                        <img src="../assets/images/all-instructor/star.png" alt="start">
                                        <img src="../assets/images/all-instructor/star-grey.png" alt="start">
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div class="swiper-slide">
                            <div class="el-temsl-text-slider">
                                <img src="../assets/images/all-instructor/qoute.png" alt="qoute image">
                                <p class="el-para">SilverZone mock tests are supported with the real-time experience
                                    of
                                    the Olympiad exam pattern, making it easier to
                                    prepare.</p>
                                <div class="el-tesmnl-rating">
                                    <img src="../assets/images/all-instructor/like-star.png" alt="rating star">
                                    <span>4.0</span>
                                    <span class="el-temnl-rating">
                                        <img src="../assets/images/all-instructor/star.png" alt="start">
                                        <img src="../assets/images/all-instructor/star.png" alt="start">
                                        <img src="../assets/images/all-instructor/star.png" alt="start">
                                        <img src="../assets/images/all-instructor/star.png" alt="start">
                                        <img src="../assets/images/all-instructor/star-grey.png" alt="start">
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div class="swiper-slide">
                            <div class="el-temsl-text-slider">
                                <img src="../assets/images/all-instructor/qoute.png" alt="qoute image">
                                <p class="el-para">These mock tests helped in my Olympiad preparation. Creating a
                                    positive difference during the exam hour, taking my
                                    preparation in the right direction by solving tricky questions and finding
                                    solutions
                                    through SilverZone mock test
                                    papers.
                                </p>
                                <div class="el-tesmnl-rating">
                                    <img src="../assets/images/all-instructor/like-star.png" alt="rating star">
                                    <span>4.0</span>
                                    <span class="el-temnl-rating">
                                        <img src="../assets/images/all-instructor/star.png" alt="start">
                                        <img src="../assets/images/all-instructor/star.png" alt="start">
                                        <img src="../assets/images/all-instructor/star.png" alt="start">
                                        <img src="../assets/images/all-instructor/star.png" alt="start">
                                        <img src="../assets/images/all-instructor/star-grey.png" alt="start">
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<!-- Testimonial Section End -->